import styled from 'styled-components';
import * as Bento from '@prezi/bento';
export const SimpleDivider = styled(Bento.Divider).withConfig({
  displayName: "Dividers__SimpleDivider",
  componentId: "zemjb1-0"
})(["margin:16px 0 4px;"]);